import {FC, KeyboardEvent, MouseEvent} from 'react';

type Icon = {
    className?: string;
    onClick: (event: KeyboardEvent | MouseEvent) => void;
};

const Hide: FC<Icon> = ({className, onClick}) => (
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path
            d="M14.5562 11.0669C14.9245 10.6553 14.8894 10.0231 14.4778 9.65481C14.0662 9.28653 13.434 9.32163 13.0658 9.7332L14.5562 11.0669ZM8.79999 16L8.05478 15.3332C7.71506 15.7128 7.71506 16.2872 8.05478 16.6669L8.79999 16ZM13.0658 22.2669C13.434 22.6784 14.0662 22.7135 14.4778 22.3452C14.8894 21.977 14.9245 21.3448 14.5562 20.9332L13.0658 22.2669ZM23.2 17C23.7523 17 24.2 16.5523 24.2 16C24.2 15.4477 23.7523 15 23.2 15V17ZM13.0658 9.7332L8.05478 15.3332L9.5452 16.6669L14.5562 11.0669L13.0658 9.7332ZM8.05478 16.6669L13.0658 22.2669L14.5562 20.9332L9.5452 15.3332L8.05478 16.6669ZM8.79999 17H23.2V15H8.79999V17Z"
            fill="#C5CDF8"
        />
        <path
            d="M1 8C1 7.44772 1.44772 7 2 7C2.55228 7 3 7.44772 3 8V24C3 24.5523 2.55228 25 2 25C1.44772 25 1 24.5523 1 24V8Z"
            fill="#C5CDF8"
        />
    </svg>
);

export default Hide;
